// extracted by mini-css-extract-plugin
export default {"ShadowContainer__Wrapper":"ShadowContainer_ShadowContainer__Wrapper__UDvkN","ShadowContainer__Wrapper_scrolled":"ShadowContainer_ShadowContainer__Wrapper_scrolled__XNxxz"};